<script lang="ts">
  export interface BtnSignOutProps {
    variant?: ButtonProps['variant']
    size?: ButtonProps['size']
    class?: ButtonProps['class']
    disabled?: boolean
    showTooltip?: boolean
    icon?: boolean
  }
</script>

<script setup lang="ts">
  import { computed } from 'vue'
  import { Button, type ButtonProps } from '@gat-ship/vue-components'
  import { useAuth0 } from '@gat-ship/auth'
  import { IconLogOut } from '@gat-ship/icons'
  import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent
  } from '@gat-ship/vue-components'

  const props = withDefaults(defineProps<BtnSignOutProps>(), {
    icon: true
  })
  const { logout } = useAuth0()

  const showLabel = computed(() => props.size !== 'icon')
</script>
<template>
  <TooltipProvider>
    <tooltip :disabled="!props.showTooltip">
      <TooltipTrigger as-child>
        <Button
          :variant="props.variant"
          :size="props.size"
          :class="props.class"
          :disabled="props.disabled"
          @click="logout()"
        >
          <IconLogOut v-if="props.icon" class="size-4" />
          <template v-if="showLabel">Sign out</template>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <div>Sign out</div>
      </TooltipContent>
    </tooltip>
  </TooltipProvider>
</template>
